import { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

export type HelpFaqItem = {
  name: string;
  question: string;
  answer: string;
  category?: string;
};

export default function HelpFaqSection({
  faqs,
  title = 'Q&A',
}: {
  faqs: HelpFaqItem[];
  title?: string;
}) {
  const [open, setOpen] = useState<string | null>(null);

  if (!faqs.length) {
    return (
      <p className="text-sm text-gray-500 border border-dashed border-gray-200 rounded-xl px-4 py-6 text-center">
        No questions published yet.
      </p>
    );
  }

  return (
    <div className="space-y-3">
      {title ? (
        <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wide">{title}</h3>
      ) : null}
      <div className="rounded-xl border border-gray-200 bg-white divide-y divide-gray-100 overflow-hidden">
        {faqs.map((faq) => {
          const isOpen = open === faq.name;
          return (
            <div key={faq.name}>
              <button
                type="button"
                className="w-full flex items-start gap-2 px-4 py-3 text-left hover:bg-gray-50"
                onClick={() => setOpen(isOpen ? null : faq.name)}
                aria-expanded={isOpen}
              >
                {isOpen ? (
                  <ChevronDown className="w-4 h-4 text-gray-400 mt-0.5 shrink-0" />
                ) : (
                  <ChevronRight className="w-4 h-4 text-gray-400 mt-0.5 shrink-0" />
                )}
                <span className="text-sm font-semibold text-gray-900">{faq.question}</span>
              </button>
              {isOpen ? (
                <div
                  className="px-4 pb-4 pl-10 text-sm text-gray-600 prose prose-sm max-w-none"
                  dangerouslySetInnerHTML={{ __html: faq.answer || '' }}
                />
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
}
